export const HOMEPAGE = "/";
export const SIGNUPPAGE = "/auth/signup";
export const LOGINPAGE = "/auth/login";
export const PROTECTEDPAGE = "/protected";

export const CUSTOMERS = "/customers";
